// extracted by mini-css-extract-plugin
module.exports = {"container":"hc","title":"hd"};